/* jkb-related.js
   関連ブロックの「Show all N / Show less」展開トグル。
   related-block.liquid が data-jkb-related-toggle ボタンと
   data-jkb-related-grid（hidden属性付きカードを含む）を出力する。
   JSが無効でも先頭 data-limit 件はDOMにそのまま出ているので壊れない。
*/
(function () {
  if (window.__jkbRelatedInitialized) return;
  window.__jkbRelatedInitialized = true;

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-jkb-related-toggle]');
    if (!toggle) return;

    var section = toggle.closest('.jkb-related');
    var grid = section && section.querySelector('[data-jkb-related-grid]');
    if (!grid) return;

    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 0;
    var cards = grid.querySelectorAll('.jkb-related__card');
    var expanded = toggle.getAttribute('aria-expanded') === 'true';

    cards.forEach(function (card, index) {
      if (index < limit) return;
      if (expanded) {
        card.hidden = true;
      } else {
        card.hidden = false;
      }
    });

    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded
      ? toggle.getAttribute('data-show-text')
      : toggle.getAttribute('data-hide-text');
  });
})();
